import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import fr from '../translations/fr.json';
import en from '../translations/en.json';
import pt from '../translations/pt.json';
import nl from '../translations/nl.json';
import de from '../translations/de.json';
import lu from '../translations/lu.json';

const UI_LANGUAGE_STORAGE_KEY = 'uiLanguage';

i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    en: { translation: en },
    pt: { translation: pt },
    nl: { translation: nl },
    de: { translation: de },
    lu: { translation: lu },
  },
  lng: localStorage.getItem(UI_LANGUAGE_STORAGE_KEY) || 'fr',
  fallbackLng: 'fr',
  keySeparator: false,
  interpolation: { escapeValue: false },
});

export default i18n;
